module.exports = __webpack_public_path__ + "static/media/AntarcticaBeta-ExtraCondMed.564c13be.woff2";